/**
 * This file was auto-generated by openapi-typescript.
 * Do not make direct changes to the file.
 */

export interface paths {
  "/v1/token-bridge/orders": {
    get: operations["TokenBridgeController_getTokenBridgeOrders"]
  }
  "/v1/token-bridge/avg-seconds-to-wrap": {
    get: operations["TokenBridgeController_getAvgSecondsToWrap"]
  }
}

export interface components {
  schemas: {
    /** @description bridge transaction */
    APIDTOBridgeStepsTransactions: {
      orders: {
        source_tx_hash: string
        source_evt_index: string
        source_chain: string
        source_asset: string
        source_amount: string
        source_fee: string
        source_sender_address: string
        source_onchain_status: string
        source_processing_status: string
        source_error: string | null
        sent_user_tx_hash: string | null
        sent_user_evt_index: string | null
        sent_user_chain: string | null
        sent_user_asset: string | null
        sent_user_amount: string | null
        sent_user_recipient_address: string | null
        sent_user_route: string | null
        sent_user_onchain_status: string | null
        sent_user_processing_status: string | null
        sent_user_error: string | null
        sent_user_order_hash: string | null
        time_to_wrap: number | null
        description: string | null
        created_at: number
        updated_at: number
      }[]
    }
    APIDTOAvgSecondsToWrap: {
      avg_seconds_to_wrap: number
    }
  }
}

export interface operations {
  TokenBridgeController_getTokenBridgeOrders: {
    parameters: {
      query: {
        address0: string
        address1: string
      }
    }
    responses: {
      /** get orders */
      default: {
        content: {
          "application/json": components["schemas"]["APIDTOBridgeStepsTransactions"]
        }
      }
    }
  }
  TokenBridgeController_getAvgSecondsToWrap: {
    parameters: {
      query: {
        from: string
        to: string
      }
    }
    responses: {
      /** get avg seconds to wrap */
      default: {
        content: {
          "application/json": components["schemas"]["APIDTOAvgSecondsToWrap"]
        }
      }
    }
  }
}

export interface external {}

export namespace ApiPaths {
  export const TokenBridgeController_getTokenBridgeOrders = {
    url: "/v1/token-bridge/orders" as const,
    method: "get" as const,
  }
  export const TokenBridgeController_getAvgSecondsToWrap = {
    url: "/v1/token-bridge/avg-seconds-to-wrap" as const,
    method: "get" as const,
  }
}
